import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgBank = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 3.063c.222 0 .441.044.645.13l.198.099.03.02 7.599 4.975.002.001.104.075c.498.392.643 1.011.43 1.546-.217.547-.763.912-1.41.912h-.42v5.572h.536c.769 0 1.392.623 1.392 1.392v1.929c0 .77-.623 1.392-1.392 1.392H4.285c-.769 0-1.392-.623-1.392-1.392v-1.929c0-.769.623-1.392 1.392-1.392h.536V10.82h-.42c-.646 0-1.193-.365-1.41-.912-.227-.57-.047-1.238.534-1.62l.002-.002 7.599-4.975.03-.02c.256-.15.548-.23.844-.23M4.393 19.606h15.213v-1.713H4.393zm10.5-8.785v5.572h2.786V10.82zM6.32 16.393h2.786V10.82H6.321zm4.286 0h2.786V10.82h-2.786zM12 4.563a.2.2 0 0 0-.078.019l-7.236 4.74h14.628l-7.238-4.74a.2.2 0 0 0-.076-.02"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgBank;
